@if (beforeTableTemplate(); as beforeTable) {
	<div class="ara-inline-edit-table__context">
		<ng-container *ngTemplateOutlet="beforeTable"></ng-container>
	</div>
}

<table *transloco="let t" mat-table [dataSource]="rows()" [trackBy]="trackRow" class="ara-inline-edit-table w-full">
	@if (leadingTemplate(); as leadTpl) {
		<ng-container matColumnDef="__leading">
			<th mat-header-cell *matHeaderCellDef>{{ leadingHeader() ? t(leadingHeader()) : '' }}</th>
			<td mat-cell *matCellDef="let row" class="pr-3">
				<ng-container *ngTemplateOutlet="leadTpl; context: { $implicit: row }"></ng-container>
			</td>
		</ng-container>
	}

	@for (col of columns(); track col.key) {
		<ng-container [matColumnDef]="col.key">
			<th mat-header-cell *matHeaderCellDef [style.width]="col.width">{{ t(col.header) }}</th>
			@if (col.cellTemplate; as cellTpl) {
				<td mat-cell *matCellDef="let row" class="py-2 pr-3">
					<!-- Kontext trägt zusätzlich die Spalte, damit EINE Zell-Vorlage spaltengetrieben rendern kann. -->
					<ng-container *ngTemplateOutlet="cellTpl; context: { $implicit: row, column: col }"></ng-container>
				</td>
			} @else {
				<td mat-cell *matCellDef="let row" [formGroup]="row.group" class="py-2 pr-3">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="ara-inline-edit-table__field">
						@if (col.decimal) {
							<input
								[formControlName]="col.key"
								matInput
								araDecimalFormat
								inputmode="decimal"
								[minValue]="col.minValue"
								[maxValue]="col.maxValue" />
						} @else {
							<input [formControlName]="col.key" matInput />
						}
						@if (col.suffix) {
							<span matSuffix class="pr-2">{{ col.suffix }}</span>
						}
					</mat-form-field>
				</td>
			}
		</ng-container>
	}

	@if (actionTemplate(); as actionTpl) {
		<ng-container matColumnDef="__actions">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let row; let i = index">
				<ng-container *ngTemplateOutlet="actionTpl; context: { $implicit: row, index: i }"></ng-container>
			</td>
		</ng-container>
	}

	<tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
	<tr class="mat-row" *matNoDataRow>
		<td class="mat-cell ara-table-empty" [attr.colspan]="displayedColumns().length">
			{{ emptyText() ? t(emptyText()) : '' }}
		</td>
	</tr>
</table>

@if (afterTableTemplate(); as afterTable) {
	<div class="ara-inline-edit-table__context">
		<ng-container *ngTemplateOutlet="afterTable"></ng-container>
	</div>
}

<!-- Kanonische Add-Zeile am Tabellenende (zentriert, Card-Fläche, Trennlinie) — dieselbe Optik wie
	 in ara-generic-table/ara-slim-table. Inhalt kommt vom Aufrufer, damit auch mehrere Aktionen
	 (z. B. „Rolle hinzufügen" je Rollentyp) hineinpassen. -->
@if (addRowTemplate(); as addRow) {
	<div class="ara-table-add-row--inline">
		<ng-container *ngTemplateOutlet="addRow"></ng-container>
	</div>
}
